import React, {useEffect} from 'react';
import {useAppDispatch} from "../../hooks/redux";
import {appSlice} from "../../store/reducers/AppSlice";
import {TransactionType} from "../../model/TransactionType";

const ExchangeTransactionsPage = () => {
    const dispatch = useAppDispatch();
    const {setTitle, setTrType} = appSlice.actions;

    useEffect(() => {
        dispatch(setTitle('Exchange Transactions'));
        dispatch(setTrType(TransactionType.Exchange));
    });

    return (
        <div>

        </div>
    );
};

export default ExchangeTransactionsPage;